import { useEffect } from 'react'
import { useDataFormat, useDataChange, useDataValue } from 'Simple/Data.js'

import View from './view.js'

export default function Logic(props) {
  let first_treatment_id = useDataFormat({
    context: 'treatments',
    viewPath: props.viewPath,
    format: treatments => (treatments.length > 0 ? treatments[0].id : null),
  })
  let selected_treatment_id = useDataValue({
    context: 'create_invoice',
    path: 'treatment_id',
    viewPath: props.viewPath,
  })
  let setTreatmentId = useDataChange({
    context: 'create_invoice',
    path: 'treatment_id',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    if (!first_treatment_id || selected_treatment_id) return

    setTreatmentId(first_treatment_id)
  }, [first_treatment_id, selected_treatment_id]) // eslint-disable-line react-hooks/exhaustive-deps
  // ignore setTreatmentId

  return <View {...props} />
}
